var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.977 5.20266L13.3337 9.58932C10.6504 10.5927 8.45703 13.766 8.45703 16.6127V33.9493C8.45703 36.7027 10.277 40.3193 12.4937 41.976L22.527 49.466C25.817 51.9393 31.2304 51.9393 34.5204 49.466L44.5537 41.976C46.7704 40.3193 48.5904 36.7027 48.5904 33.9493V16.6127C48.5904 13.7427 46.397 10.5693 43.7137 9.56599L32.0704 5.20266C30.087 4.47932 26.9137 4.47932 24.977 5.20266Z",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6162 27.6966L25.3729 31.4533L35.4062 21.4199",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.580ac0e614cd70056e4006152cba00fe.svg";
export { ForwardRef as ReactComponent };